import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=1b07c24f&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=js"
export * from "./Copy.vue?vue&type=script&lang=js"
import style0 from "./Copy.vue?vue&type=style&index=0&id=1b07c24f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07c24f",
  null
  
)

export default component.exports